/**
 * Removes all whitespace characters from a string.
 *
 * @param {string} value The string to sanitize.
 * @return {string} The string with all whitespace removed.
 */
export function removeWhitespace(value) {
  return value.replace(/\s/g, '');
}

/**
 * Strips whitespace from specified string params in a params object.
 * Returns an object with `params` (sanitized copy) and `modified` (boolean).
 *
 * @param {Object} params The route params object.
 * @param {string[]} keys The keys to sanitize.
 * @return {{ params: Object, modified: boolean }}
 */
export function sanitizeParams(params, keys) {
  const result = { ...params };
  let modified = false;

  keys.forEach(key => {
    const value = result[key];
    if (typeof value === 'string' && /\s/.test(value)) {
      result[key] = removeWhitespace(value);
      modified = true;
    }
  });

  return { params: result, modified };
}
